/* ============================================================
   CUSTOMDO — cdx-wizard.js  (v2)
   Schritt-für-Schritt-Führung über dem Teeinblue-Konfigurator.

   STANDARDMÄSSIG AUS. An: ?cdxwizard=on   Aus: ?cdxwizard=off

   v2 nach Review: "innovativ, konstant, ohne Erklärtexte".
   - Auswahl-Schritte schalten SELBST weiter (kein Weiter-Button, kein Hinweis).
     Nur Schritte mit freien Texteingaben behalten einen Button.
   - Kopf/Fuß werden an Ort und Stelle aktualisiert statt neu eingefügt
     => kein Umspringen, keine Layout-Sprünge, weniger Mutationen.
   - Felder starten unsichtbar (CSS .cdx-wz-ready), sobald der Wizard einmal
     stand. Baut Teeinblue neu auf, blitzt nicht kurz das ganze Formular auf.
   - Kein Auto-Scroll mehr; nur wenn der Konfigurator ganz aus dem Bild ist.
   - Fortschritt = Punkte. Erledigte Punkte sind anklickbar (ersetzt "Ändern").

   Gebaut auf den echten Klassen aus dem DOM-Abzug vom 25.07.2026:
     .tee-customization-form > .tee-field.tee-field--<ID>-<slug>.tee-field--<typ>
       .tee-field__header > .tee-field__heading > span  (+ span.tee-asterisk)
       .tee-field__input  > .tee-row > .tee-radio > input.tee-checkbox-input

   HARTE REGELN (aus den Fehlern der letzten Runden):
   - Teeinblues DOM wird nie verschoben oder umgebaut.
   - Kein pauschales Abschalten von animation/transition.
   - Klassen nur bei echter Änderung schreiben (sonst Mutations-Schleife).
   - Selbstabbau, wenn nach dem Aufbau kein Eingabefeld sichtbar ist.
   ============================================================ */
(function () {
  'use strict';

  var ON_KEY = 'cdxWizard';
  var root = document.documentElement;

  function param(n) { var m = new RegExp('[?&]' + n + '=([^&]+)').exec(location.search); return m ? m[1] : null; }
  /* STANDARD WIEDER AUS — Testergebnis vom 01.08.2026 ueber alle 25 Konfigurator-
     Produkte: 23 davon defekt, und zwar DURCH diesen Wizard. Das feste
     Vier-Schritte-Modell (Vorlage & Form / Deine Orte / Text & Schrift /
     Groesse & Extras) passt auf das Reiseposter, aber nicht auf 25
     unterschiedliche Kampagnen. Felder, die in keinen Schritt passen, landeten
     im falschen — und weil der Wizard alles ausblendet, was nicht zum aktuellen
     Schritt gehoert, fehlten bei Hundemarken die Namensfelder, bei Schnapsbaenken
     der Wunschtext, bei Gedenktafeln der Foto-Upload. Sie waren nie weg, sie waren
     versteckt. Dazu Titel wie "Deine Orte" bei Produkten ohne Orte.

     Konsequenz: Der Wizard darf erst wieder standardmaessig laufen, wenn er seine
     Schritte AUS DER KAMPAGNE ableitet statt aus einer festen Liste — und wenn er
     nichts mehr versteckt, was er nicht sicher zuordnen kann.
     Bis dahin: nur mit ?cdxwizard=on. */
  function enabled() {
    var p = param('cdxwizard');
    try {
      if (p === 'on' || p === 'off') localStorage.setItem(ON_KEY, p);
      return localStorage.getItem(ON_KEY) === 'on';
    } catch (e) { return p === 'on'; }
  }

  var STEPS = [
    { title: 'Vorlage & Form', test: /vorlage|kartenform|design|form/i },
    { title: 'Deine Orte', test: /anzahl|standort|orte|adresse|koordinat|datum/i },
    { title: 'Text & Schrift', test: /titel|text|schrift|font|botschaft|name/i },
    { title: 'Größe & Extras', test: /größe|groesse|grosse|rahmen|farbe|material/i }
  ];

  function heading(f) {
    var h = f.querySelector('.tee-field__heading');
    return h ? (h.textContent || '').replace(/\*/g, '').replace(/\s+/g, ' ').trim() : '';
  }
  function required(f) { return !!f.querySelector('.tee-asterisk'); }
  function station(f) { return /^\s*\d{1,2}\s*\./.test(heading(f)); }
  /* Auswahlfeld = ausschliesslich Radios/Checkboxen. Nur solche Schritte
     duerfen selbst weiterschalten; bei freiem Text waere das uebergriffig. */
  function choiceOnly(f) {
    var all = f.querySelectorAll('input,select,textarea');
    if (!all.length) return false;
    for (var i = 0; i < all.length; i++) {
      var t = all[i].type;
      if (t !== 'radio' && t !== 'checkbox' && t !== 'hidden') return false;
    }
    return true;
  }
  function filled(f) {
    var c = f.querySelectorAll('input[type="radio"],input[type="checkbox"]');
    if (c.length) { for (var i = 0; i < c.length; i++) if (c[i].checked) return true; return false; }
    var ins = f.querySelectorAll('input,select,textarea');
    for (var j = 0; j < ins.length; j++) if ((ins[j].value || '').trim() !== '') return true;
    return false;
  }
  function fields(form) {
    var all = [].slice.call(form.querySelectorAll('.tee-field'));
    return all.filter(function (el) { return !all.some(function (o) { return o !== el && o.contains(el); }); });
  }
  function stepOf(f, last) {
    if (station(f)) return 1;
    var h = heading(f);
    for (var i = 0; i < STEPS.length; i++) if (STEPS[i].test.test(h)) return i;
    return last < 0 ? 0 : last;
  }

  /* ---------- Zustand ---------- */
  var current = 0;
  var manual = false;      /* Nutzer ist bewusst zurueckgesprungen => nicht auto-weiter */
  var applying = false;
  var lastSig = '';
  var lastOk = 0;
  var head = null, foot = null;

  function setClass(el, cls, on) {
    var has = el.classList.contains(cls);
    if (on && !has) el.classList.add(cls);
    else if (!on && has) el.classList.remove(cls);
  }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }

  /* ---------- Höhen-Stabilisator ----------
     Teeinblue verwirft bei jeder Auswahl das ganze Formular und baut es neu auf.
     Dazwischen ist der Container fuer einen Frame leer: die Hoehe faellt auf 0
     und schnellt zurueck — das ist das "groesser und kleiner werden". Wir halten
     die zuletzt gueltige Hoehe fest, bevor der Frame gezeichnet wird, und lassen
     sie danach weich auf die neue Hoehe laufen (CSS-Transition auf min-height). */
  var stableH = 0, hTimer = null;
  function lockHeight() {
    if (!stableH || !root.classList.contains('cdx-wizard')) return;
    var form = document.querySelector('.tee-customization-form');
    if (form && form.style.minHeight !== stableH + 'px') form.style.minHeight = stableH + 'px';
  }
  function settleHeight(form) {
    var held = form.style.minHeight;
    form.style.minHeight = '';
    var nat = form.offsetHeight;                 /* natuerliche Hoehe des neuen Schritts */
    if (!nat) { form.style.minHeight = held; return; }
    if (held && held !== nat + 'px') {
      /* Richtung entscheidet über das Tempo — Messung vom 25.07.2026:
         Beim WACHSEN (neue Stationsfelder) verschob die 0,28-s-Animation den Text
         UNTER dem Konfigurator verzögert; der Browser wertet das als eigenen
         Layout-Sprung (CLS 0,096 mit Wizard gegen 0,017 ohne), weil er nicht mehr
         im 500-ms-Fenster nach dem Klick liegt. Wachsen passiert deshalb SOFORT:
         Es folgt unmittelbar auf den Klick, wird dadurch erwartet und nicht
         gewertet. Nur das Schrumpfen läuft weich — dort ist der harte Sprung
         wirklich unangenehm. */
      var grow = nat > parseFloat(held);
      form.style.transition = 'none';
      form.style.minHeight = held;               /* alte Hoehe halten … */
      void form.offsetHeight;                    /* … Reflow erzwingen … */
      if (!grow) form.style.transition = '';     /* schrumpfen: weich */
      form.style.minHeight = nat + 'px';
      if (grow) { void form.offsetHeight; form.style.transition = ''; }
    }
    stableH = nat;
    clearTimeout(hTimer);
    hTimer = setTimeout(function () {
      if (form.style.minHeight === nat + 'px') form.style.minHeight = '';
    }, 420);
  }

  function cleanup() {
    var form = document.querySelector('.tee-customization-form');
    if (form) form.style.minHeight = '';
    clearTimeout(hTimer);
    stableH = 0;
    [head, foot].forEach(function (el) { if (el && el.parentNode) el.parentNode.removeChild(el); });
    head = foot = null;
    [].slice.call(document.querySelectorAll('.tee-field')).forEach(function (f) {
      f.classList.remove('cdx-step-show', 'cdx-need', 'cdx-step-hidden');
    });
  }
  function teardown(reason) {
    cleanup();
    root.classList.remove('cdx-wizard', 'cdx-wz-ready');
    if (reason && window.console) console.warn('[cdx-wizard] abgebaut:', reason);
  }
  window.cdxWizardOff = function () { try { localStorage.setItem(ON_KEY, 'off'); } catch (e) {} teardown('manuell'); };

  /* ---------- Kopf/Fuss einmalig anlegen, danach nur noch aktualisieren ---------- */
  function ensureChrome(form) {
    if (!head || !head.parentNode) {
      head = document.createElement('div');
      head.className = 'cdx-wz-head';
      head.innerHTML = '<div class="cdx-wz-dots"></div><div class="cdx-wz-title"></div>';
      form.parentNode.insertBefore(head, form);
    }
    if (!foot || !foot.parentNode) {
      foot = document.createElement('div');
      foot.className = 'cdx-wz-foot';
      foot.innerHTML = '<button type="button" class="cdx-wz-next" hidden></button>';
      form.parentNode.insertBefore(foot, form.nextSibling);
      foot.querySelector('.cdx-wz-next').addEventListener('click', function () {
        manual = false; current++; render(true);
      });
    }
  }

  function render(force) {
    if (applying) return;
    var form = document.querySelector('.tee-customization-form');
    if (!form) return;
    var fs = fields(form);
    if (!fs.length) return;

    var sig = current + '|' + manual + '|' + fs.map(function (f) {
      return heading(f) + ':' + (filled(f) ? '1' : '0');
    }).join('|');
    if (!force && sig === lastSig) return;
    lastSig = sig;

    applying = true;
    try { paint(form, fs); } finally { setTimeout(function () { applying = false; }, 0); }
  }

  /* ---------- Erstes Tor automatisch oeffnen (global, alle Produkte) ----------
     Befund vom 25.07.2026: In den Teeinblue-Einstellungen steht shop-weit
     auto_select_first_template = false, und in den Kampagnen sind praktisch alle
     Ebenen abhaengig (show_by_default false). Dadurch zeigt der Konfigurator
     zunaechst NUR das Vorlagen-Feld; wer dort nicht klickt, sieht einen
     Konfigurator, der stehenbleibt. Betroffen ist jedes Teeinblue-Produkt.

     Wir waehlen deshalb die erste Vorlage selbst aus — exakt das, was der
     App-Schalter tun wuerde. Danach erscheinen die Folgefelder von allein.

     Enge Grenzen, damit dem Kunden nie eine Kaufentscheidung abgenommen wird:
       - nur das ERSTE Feld des Formulars (die Vorlage), kein weiteres Tor
       - nur reine Auswahlfelder, nur wenn noch nichts gewaehlt ist
       - nur wenn KEINE der Optionen einen Aufpreis traegt (+ oder Waehrung)
       - nur einmal je Feld und nur in den ersten 8 Sekunden nach dem Laden
       - abschaltbar mit ?cdxautopick=off
     Geklickt wird der echte Input, damit Teeinblues eigene Logik normal laeuft. */
  var picked = {};
  var t0 = Date.now();
  function autoPickFirstGate(fs) {
    if (param('cdxautopick') === 'off') return false;
    if (Date.now() - t0 > 8000) return false;
    var f = fs[0];
    if (!f || !required(f) || !choiceOnly(f) || filled(f)) return false;
    var key = heading(f);
    if (!key || picked[key]) return false;
    var opts = [].slice.call(f.querySelectorAll('.tee-radio'));
    if (!opts.length) return false;
    var priced = opts.some(function (o) { return /[+€$]|\d[.,]\d{2}/.test(o.textContent || ''); });
    if (priced) return false;                        /* Aufpreis => Kundenentscheidung */
    var input = opts[0].querySelector('input');
    if (!input) return false;
    picked[key] = 1;
    input.click();
    return true;
  }

  /* ---------- Standardwerte der App mit der Anzeige abgleichen ----------
     Befund vom 01.08.2026: Setzt man in Teeinblue "Default value" (z. B. Kartenform
     = Herz), schreibt die App den Wert in die Warenkorb-Eigenschaft
     properties[Kartenform] — den sichtbaren Radiobutton waehlt sie aber NICHT aus.
     Dadurch greift ihre eigene Abhaengigkeitslogik nicht, und das Adressfeld
     erscheint erst nach einem manuellen Klick. Genau diese Luecke schliessen wir:
     Ist eine Eigenschaft bereits gesetzt, aber die passende Option nicht markiert,
     klicken wir sie an.

     Das ist ausdruecklich KEINE Entscheidung fuer den Kunden: Der Wert steht
     bereits in der Warenkorb-Eigenschaft und wuerde ohnehin mitbestellt. Wir
     sorgen nur dafuer, dass die Anzeige die Wahrheit zeigt. */
  var synced = {};
  function syncAppDefaults(form) {
    if (Date.now() - t0 > 10000) return false;
    var hidden = form.closest('form') || document;
    var props = [].slice.call(hidden.querySelectorAll('input[type="hidden"][name^="properties["]'));
    for (var i = 0; i < props.length; i++) {
      var m = /^properties\[(.+)\]$/.exec(props[i].name || '');
      var val = (props[i].value || '').trim();
      if (!m || !val) continue;
      var label = m[1].trim().toLowerCase();
      var key = label + '=' + val;
      if (synced[key]) continue;
      var target = null;
      [].slice.call(form.querySelectorAll('.tee-field')).forEach(function (f) {
        if (heading(f).toLowerCase() === label) target = f;
      });
      if (!target || filled(target)) continue;
      var hit = null;
      [].slice.call(target.querySelectorAll('.tee-radio')).forEach(function (o) {
        if ((o.textContent || '').trim() === val) hit = o;
      });
      if (!hit) continue;
      var input = hit.querySelector('input');
      if (!input) continue;
      synced[key] = 1;
      input.click();
      return true;   /* T&B rendert neu — der naechste Durchlauf macht weiter */
    }
    return false;
  }

  function paint(form, fs) {
    ensureChrome(form);
    /* Nach einem eigenen Klick MUSS ein weiterer Durchlauf folgen. Der Klick loest
       ein change-Ereignis aus, das noch waehrend dieses Aufbaus eintrifft und von
       der Schleifensperre (applying) verschluckt wird — ohne den Nachzuegler bleibt
       der Wizard mit leerem Kopf stehen. Gefunden mit der Nachbildung eines
       Produkts ohne Stationen (Hundemarke), 01.08.2026. */
    if (syncAppDefaults(form)) { setTimeout(function () { render(true); }, 80); return; }
    if (autoPickFirstGate(fs)) { setTimeout(function () { render(true); }, 80); return; }

    var buckets = STEPS.map(function () { return []; });
    var last = -1;
    fs.forEach(function (f) { var i = stepOf(f, last); last = i; buckets[i].push(f); });
    var live = [];
    buckets.forEach(function (b, i) { if (b.length) live.push({ i: i, fields: b }); });
    if (!live.length) return;
    if (current >= live.length) current = live.length - 1;
    if (current < 0) current = 0;

    /* Sichtbarkeit */
    live.forEach(function (s, pos) {
      s.fields.forEach(function (f) { setClass(f, 'cdx-step-show', pos === current); });
    });

    var step = live[current];
    var missing = step.fields.filter(function (f) { return required(f) && !filled(f); });

    /* Die naechste offene Pflichtangabe markiert sich selbst — statt eines Satzes.
       Ueber ALLE Felder laufen, nicht nur ueber die des aktuellen Schritts: sonst
       bleibt die Markierung an einem Feld haengen, das gerade gar nicht dran ist. */
    fs.forEach(function (f) { setClass(f, 'cdx-need', f === missing[0]); });

    /* Punkte */
    var dots = head.querySelector('.cdx-wz-dots');
    if (dots.children.length !== live.length) {
      dots.innerHTML = '';
      live.forEach(function (s, pos) {
        var d = document.createElement('span');
        d.className = 'd';
        d.textContent = String(pos + 1);
        d.addEventListener('click', function () {
          if (!d.classList.contains('is-done')) return;
          manual = true; current = pos; render(true);
        });
        dots.appendChild(d);
      });
    }
    [].slice.call(dots.children).forEach(function (d, pos) {
      setClass(d, 'is-now', pos === current);
      setClass(d, 'is-done', pos < current);
    });
    setText(head.querySelector('.cdx-wz-title'), STEPS[step.i].title);

    /* Fuss: Button nur, wenn der Schritt freie Eingaben enthaelt (dort kann der
       Wizard nicht wissen, wann der Kunde fertig ist). Sonst gar kein Button. */
    var isLast = current === live.length - 1;
    var autoStep = step.fields.every(function (f) { return !required(f) || choiceOnly(f); });
    var btn = foot.querySelector('.cdx-wz-next');
    var showBtn = !isLast && !autoStep;
    btn.hidden = !showBtn;
    setClass(foot, 'has-btn', showBtn);
    if (showBtn) {
      setText(btn, 'Weiter zu „' + STEPS[live[current + 1].i].title + '"');
      if (btn.disabled !== (missing.length > 0)) btn.disabled = missing.length > 0;
    }

    /* Selbstweiterschalten: alle Pflichtangaben des Schritts sind Auswahlfelder
       und beantwortet => der naechste Schritt erscheint von allein. */
    if (!isLast && autoStep && !missing.length && !manual) {
      setTimeout(function () {
        if (current === live.indexOf(step)) { current++; render(true); }
      }, 260);
    }

    /* Fail-safe + Bereitschaft */
    var visible = [].slice.call(form.querySelectorAll('input,select,textarea'))
      .filter(function (i) { return i.type !== 'hidden' && i.offsetHeight > 0; });
    if (!visible.length) { teardown('kein sichtbares Eingabefeld'); return; }
    lastOk = Date.now();
    root.classList.add('cdx-wz-ready');
    settleHeight(form);   /* Hoehe weich auf den neuen Schritt fuehren */

    /* Nur zurueckholen, wenn der Konfigurator komplett aus dem Bild gescrollt ist —
       kein Scrollen bei jedem Schritt (das war das "Springen"). */
    var r = form.getBoundingClientRect();
    if (r.bottom < 0 || r.top > window.innerHeight) {
      window.scrollTo({ top: window.scrollY + r.top - 90, behavior: 'smooth' });
    }
  }

  /* Wachhund: Felder sind per CSS versteckt, sobald .cdx-wz-ready gesetzt ist.
     Sollte das Rendern je aussetzen, wird die Klasse entfernt und das flache
     Formular ist sofort wieder vollstaendig da. */
  setInterval(function () {
    if (!root.classList.contains('cdx-wz-ready')) return;
    if (Date.now() - lastOk > 8000 && !document.querySelector('.tee-field.cdx-step-show')) {
      teardown('Wachhund: kein gueltiger Aufbau');
    }
  }, 2000);

  function start() {
    if (!enabled()) { if (root.classList.contains('cdx-wizard')) teardown(''); return; }
    if (!document.querySelector('#teeinblue-form')) return;
    root.classList.add('cdx-wizard');
    render(false);
  }

  var raf = null;
  function schedule() { if (raf) return; raf = requestAnimationFrame(function () { raf = null; start(); }); }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);

  new MutationObserver(function () { lockHeight(); schedule(); })
    .observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('change', function () { manual = false; schedule(); }, true);
  document.addEventListener('input', schedule, true);
})();
